import { IncidentReport } from './InterfacesServer';

export function applyLoggedInUserDepartment(report: IncidentReport, loggedInUserDepartment?: string | null): IncidentReport {
    if (report.department?.trim()) return report;
    const department = loggedInUserDepartment?.trim();
    return department ? { ...report, department } : report;
}
